exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".qrcode-image{\n  width: 4em;\n}\n", ""]);

